/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { TeamWhatsapp, TeamInstagram } from './icons.jsx'

const WA = 'https://wa.me/989195550535?text=سلام%20وقتتون%20بخیر.%20می%E2%80%8Cخواستم%20در%20مورد%20کلاس%E2%80%8Cهای%20حضوریتون%20مشاوره%20بگیرم'

const PEOPLE = [
  { name: 'علی حسینی', role: 'سرمربی', instagram: 'https://instagram.com/alihosseini_workout' },
  { name: 'پریا نوروزی', role: 'سرمربی', instagram: 'https://instagram.com/parianoroozii' },
]

export default function Team() {
  return (
    <div className="lp-team">
      <section className="tm" id="team">
        <h2 className="tm-title">تیم ما</h2>
        <div className="tm-card">
          <div className="tm-photo">
            <img
              src="a/ali-and-paria-04-1024x907-67e504.webp"
              srcSet="a/ali-and-paria-04-480x425-8e91bb.webp 480w, a/ali-and-paria-04-800x708-1d809e.webp 800w, a/ali-and-paria-04-1024x907-67e504.webp 1024w"
              sizes="(max-width:767px) 100vw, 560px"
              width="1024"
              height="907"
              alt="علی حسینی و پریا نوروزی"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="tm-people">
            {PEOPLE.map((p) => (
              <article className="tm-person" key={p.name}>
                <h3>{p.name}</h3>
                <span className="tm-role">{p.role}</span>
                <div className="tm-links">
                  <a href={WA} target="_blank" rel="nofollow noopener" aria-label={'واتس‌اپ ' + p.name}>
                    <TeamWhatsapp />
                  </a>
                  <a href={p.instagram} target="_blank" rel="noopener" aria-label={'اینستاگرام ' + p.name}>
                    <TeamInstagram />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
